import React, { useState } from 'react'
import styled from 'styled-components'
import { Dialog, DialogContent } from '@material-ui/core'
import { Button } from '@material-ui/core'
import { Image, Spinner } from 'ui'
import { observer } from 'mobx-react'
import { useTranslation } from 'react-i18next'
import useStore from 'store'

import Close1Icon from 'assets/icons/ims/Close2.svg'
import EmergencyIcon3 from 'assets/icons/ims/EmergencyIcon3.svg'

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 31.989px;
  flex-shrink: 0;display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
  border-radius: 8px;
  background: #FFF;
`
const DialogBody = styled(DialogContent)`
  background: white;
  border-top-width: 1px;
  overflow-y: none;
`
const TopContainer = styled.div`
  display: flex;
  padding-right: 0;
  justify-content: flex-end;
  align-items: flex-start;
  gap: 15.994px;
  flex-shrink: 0;
  align-self: stretch;
`
const BottomContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 11.989px;
  flex-shrink: 0;
  align-self: stretch;
`
const ConfirmButton = styled(Button)`
  display: flex;
  height: 40px;
  padding: 7px 10px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 6px;
  background: #F1F5F9;
  color: #0F172A;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const DeleteButton = styled(Button)`
  display: flex;
  padding: 8.724px 15.875px 7.276px 15.994px;
  justify-content: center;
  align-items: center;
  border-radius: 6px;
  background: #DC2626;
  color: #FFF;
  text-align: center;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`
const CloseButton = styled(Button)`
  min-width: 0px;
  padding: 0px;
`
const ImageIcon = styled(Image)`
  display: flex;
  width: 27.983px;
  height: 27.983px;
  padding: 4px;
  flex-direction: column;
  align-items: flex-start;
`
const ImageEmergencyIconContainer = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 30px;
  background: rgba(220, 38, 38, 0.10);
`
const ImageEmergencyIcon = styled(Image)`
  width: 20.969px;
  height: 20.969px;
`
const TopHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 7.997px;
  flex: 1 0 0;
`
const TopHeader1 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #E7000B;
  font-family: Rubik;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 28px;
`
const TopHeader2 = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  align-self: stretch;
  color: #64748B;
  text-align: right;
  font-family: Rubik;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
`
const TopHeader3 = styled.div`
  display: flex;
  width: 100%;
  padding: 0 3px 0 3px;
  justify-content: flex-start;
  align-items: center;
  color: #FB2C36;
  font-family: Rubik;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`

const RemoveProtocolModal = ({ open, closeModal, protocolId, protocolTitle, onDeleted }: any) => {
  const { t } = useTranslation('protocols')
  const { protocolsStore } = useStore()
  const [deleting, setDeleting] = useState(false)

  const handleDelete = async () => {
    setDeleting(true)
    const res = await protocolsStore.deleteProtocol(protocolId)
    setDeleting(false)
    if (res) {
      onDeleted?.()
      closeModal()
    }
  }

  return (
    <>
      <Dialog style={{ zIndex: 1300 }} open={open} maxWidth={'lg'}>
        <DialogBody>
          <BodyContainer>
            <TopContainer>
              <TopHeader>
                <TopHeader1>{t`remove_protocol_title`}</TopHeader1>
                <TopHeader2>
                  {t`remove_protocol_question`} ״<b>{protocolTitle}</b>״?
                </TopHeader2>
                <TopHeader3>{t`action_irreversible_warning`}</TopHeader3>
              </TopHeader>
              <CloseButton onClick={closeModal}>
                <ImageIcon src={Close1Icon} />
              </CloseButton>
            </TopContainer>
            <BottomContainer>
              <ConfirmButton onClick={closeModal}>{t`cancel`}</ConfirmButton>
              <DeleteButton onClick={handleDelete} disabled={deleting}>
                {deleting ? <Spinner size={16} /> : t`confirm_delete`}
              </DeleteButton>
            </BottomContainer>
          </BodyContainer>
        </DialogBody>
      </Dialog>
    </>
  )
}

export default observer(RemoveProtocolModal)
